// @flow

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useLocation, Redirect } from 'react-router-dom';
import qs from 'query-string';

import withRouteTracker from 'common/middleware/RouteTracker';
import { ChangePassword } from 'platform/common/components/changePassword';
import LoginPageWrap from './components/LoginPageWrap';

import Product from 'common/enums/Product';
import useResolvedClientId from 'common/hooks/useResolvedClientId';
import { ProviderDataFetcher } from 'common/modules/provider';

const AppChangePasswordContainer = (): React.Node => {
    const location = useLocation();
    const { userId } = qs.parse(location.search);
    const { t } = useTranslation('settings');
    const { providerId } = useResolvedClientId();
    if (!userId) {
        return <Redirect to="/login" />;
    }
    return (
        <ProviderDataFetcher providerId={providerId}>
            <Helmet defer={false}>
                <title>{t('changePassword')}</title>
            </Helmet>
            <LoginPageWrap>
                <ChangePassword username={userId} />
            </LoginPageWrap>
        </ProviderDataFetcher>
    );
};

export default (withRouteTracker(
    AppChangePasswordContainer,
    Product.PLATFORM
): React.AbstractComponent<{}>);
